module.exports = __webpack_public_path__ + "static/media/view0002.3ef60e53.jpg";